/**
 * @file step
 * @author zhaomiaoyuan
 */
import React, {useCallback} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import InputFormItem from '../../components/InputFormItem/index.tsx';

import {validate, recordProxy} from '../../util';

import {Button} from 'antd';

const Step1 = (props) => {
    const {
        updateData,
        data,
        inputPlaceholder,
        searchFn
    } = props;
    /* eslint-disable */
    const nextClick = useCallback(() => {
        recordProxy('report-modify_nextStep', 'click', data.phone);
        updateData({
            phoneErr: ''
        });
        if (!data.phone) {
            updateData({
                phoneErr: '不能为空'
            });
            return;
        }
        if (validate(data.phone)) {
            updateData({
                phoneErr: '号码格式不正确'
            });
            return;
        }
        searchFn(data);
    });

    // const searchFn = (data) => {
    //     recordProxy(pageType, 'click', 'search');
    //     let json = {
    //         search: data.phone
    //     };
    //     const fetchMark = (params) => fetchPhoneType({
    //         ...json,
    //         ...params
    //     }).then(data => {
    //         console.log('data======')
    //         console.log(data)
    //         if (data && data.code === 200 && data.data.list[0]) {
    //             updateData({
    //                 phoneName: data.data.list[0].name,
    //                 curStep: 2,
    //                 markType: data.data.list[0].tagId
    //             });
    //         } else if (data && data.code === 200 && data.data.list.length === 0) {
    //             message.error('该号码未认证，无需进行修改');
    //         } else {
    //             message.error(data ? data.message : '请求错误');
    //         }
    //     });
    //     bCat_2055_request(fetchMark);
    // }
    /* eslint-enable */
    return (
        <div className="step-1">
            <InputFormItem
                placeholder={inputPlaceholder}
                type="phone"
                data={data}
                updateData={updateData}
                isMsgRequired
            />
            <Button
                type="primary"
                className="btn-step1"
                onClick={nextClick}
            >
                下一步
            </Button>
        </div>
    );
};

Step1.propTypes = {
    updateData: PropTypes.func,
    data: PropTypes.object,
    fetchAppealSearch: PropTypes.func,
    inputPlaceholder: PropTypes.string,
    fetchPhoneType: PropTypes.func,
    pageType: PropTypes.string,
    searchFn: PropTypes.func
};

export default withRouter(Step1);